<template>
  <div class="newsDetail">
    <carousel v-if="configData?.news_banner?.length > 0" :imgList="configData?.news_banner" class="carousel" ref="carouselRef"></carousel>
    <div v-if="newsDetail.title || newsDetail.date || newsDetail.content" class="newsDetail_content" ref="contentRef">
      <div class="newsDetail_content_top" v-if="newsDetail.title || newsDetail.date" ref="titleRef">
        <div v-if="newsDetail.title" class="newsDetail_content_title">{{ newsDetail.title }}</div>
        <div v-if="newsDetail.date" class="newsDetail_content_date">{{ dayjs(newsDetail.date).format('YYYY-MM-DD') }}</div>
      </div>
      <!-- 使用抽取的组件 -->
      <RichTextWithImages
        v-if="newsDetail.content"
        :content="newsDetail.content"
        :enable-image-preview="true"
        :max-image-width="'100%'"
      />
    </div>
    <!-- 暂无数据 -->
    <div v-if="(!newsDetail.title) && (!newsDetail.date) && (!newsDetail.content)" class="empty_box bm bm-ver bm-ac bm-pc">
      <img src="@/assets/empty_icon.png" alt="">
      <div class="empty_text">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import carousel from '@/components/carousel.vue'
import RichTextWithImages from '@/components/RichTextWithImages.vue'
import dayjs from 'dayjs'
import { useConfigStore } from "@/stores/index.ts"

interface NewsDetail {
  title: string
  date: string
  content: string
  [key: string]: any
}

const route = useRoute()
const store = useConfigStore()

// 从store获取新闻详情
const newsDetail = computed(() => {
  console.log(store.getNewsDetail(),"store.getNewsDetail()");
  return store.getNewsDetail() || {
    title: '',
    date: '',
    content: ''
  }
})

// 从store获取配置数据
const configData = computed(() => {
  return store.configData
})

// 添加对内容区域和标题区域的引用
const contentRef = ref<HTMLElement | null>(null)
const titleRef = ref<HTMLElement | null>(null)
const carouselRef = ref<InstanceType<typeof carousel> | null>(null)

onMounted(async () => {
  // 等待DOM更新完成
  await nextTick()
  
  // 如果有轮播图，滚动到内容区域
  if (configData.value?.news_banner?.length > 0) {
    // 等待轮播图渲染完成
    setTimeout(() => {
      if (titleRef.value) {
        // 获取标题元素的位置信息
        const rect = titleRef.value.getBoundingClientRect()
        const offset = 100 // 设置偏移量，使标题部分可见
        const scrollTop = window.pageYOffset + rect.top - offset

        // 滚动到标题上方位置
        window.scrollTo({
          top: scrollTop,
          behavior: 'smooth'
        })
      } else if (contentRef.value) {
        // 如果没有标题区域，就滚动到内容区域顶部
        contentRef.value.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        })
      }
    }, 100) // 短暂延迟确保轮播图完全渲染
  }
})
</script>

<style lang="styl">
.newsDetail {
  width: 100%;
  min-height: calc(100% - 70px - 220px);
  min-width: 1200px;
  .carousel{
    margin-bottom 80px
  }
  .newsDetail_content {
    padding: 20px 200px 100px 200px;
    .newsDetail_content_top {
      padding-bottom: 30px;
      border-bottom: 1px solid #eee;
      margin-bottom: 30px;

      .newsDetail_content_title {
        font-size: 23px;
        font-weight: 500;
        margin-bottom: 20px;
        color: #323232;
        text-align: center;
      }

      .newsDetail_content_date {
        font-size: 12px;
        color: #858585;
        line-height: 12px;
        text-align: center;
      }
    }
  }

  @media (max-width: 1400px) {
    .newsDetail_content {
      padding: 20px 100px 100px 100px;
    }
  }
  .empty_box{
    width: 100%;
    height: 100%;
    min-height: 60vh;
  }
}
</style>